import { useQuery } from "@tanstack/react-query";
import { useAuth } from "../../../Context/AuthContext";
import { getRCSHealthApi } from "../api/RCSDashboardApi";

export const useRCSHealth = () => {
  const auth = useAuth();
  const user = auth.getSessionData();
  return useQuery({
    queryKey: ["RCSHealth"],
    queryFn: async () => await getRCSHealthApi({ token: user.token }),
    refetchOnWindowFocus: false,
    initialData: [],
  });
};
